import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppContext } from '../context/RevisionContext';
import SectionList from './SectionList';
import CardList from './CardList';

/**
 * Section Manager component
 * Manages sections and cards within sections
 */
const SectionManager: React.FC = () => {
  const navigate = useNavigate();
  const { sectionId } = useParams<{ sectionId: string }>();
  const { sections, currentSection, setCurrentSection, isLoading, refreshSections, config } = useAppContext();

  // Set current section based on URL parameter
  React.useEffect(() => {
    if (sectionId && sections.length > 0) {
      const section = sections.find(s => s.id === sectionId);
      if (section) {
        setCurrentSection(section);
      }
    }
  }, [sectionId, sections, setCurrentSection]);

  if (isLoading) {
    return (
      <div className="section-manager">
        <div className="loading">Loading...</div>
      </div>
    );
  }

  return (
    <div className="section-manager">
      <header className="section-manager-header">
        <h1>Section Manager</h1>
        <button 
          className="btn btn-secondary"
          onClick={() => navigate(config.routing.basePath)}
        >
          Back to Dashboard
        </button>
      </header>

      <div className="section-manager-content">
        {currentSection ? (
          <div className="section-detail">
            <h2>{currentSection.name}</h2>
            <p>{currentSection.description || 'No description'}</p>
            <p className="section-stats">
              {currentSection.cardCount} cards
            </p>
            <CardList 
              sectionId={currentSection.id} 
              onCardsChange={refreshSections}
            />
          </div>
        ) : (
          <SectionList sections={sections} onSectionsChange={refreshSections} />
        )}
      </div>
    </div>
  );
};

export default SectionManager;
